import { z } from "zod";

export type SmsConversationResponse = z.infer<typeof SmsConversationResponseSchema>;
export const SmsConversationResponseSchema = z.object({
  id: z.string(),
  sms_conversation_id: z.string(),
  url: z.string(),
});
